import { MutationHookOptions, useMutation } from '@apollo/client';
import setPrimaryDepotContactMutation from './setPrimaryDepotContactMutation.graphql';

export const useSetPrimaryDepotContactMutation = (
  options?: MutationHookOptions<
    SetPrimaryDepotContactMutation,
    SetPrimaryDepotContactMutationVariables
  >,
) => {
  return useMutation<
    SetPrimaryDepotContactMutation,
    SetPrimaryDepotContactMutationVariables
  >(setPrimaryDepotContactMutation, options);
};
